import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import style from './DepartmentInform.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import {useNavigate, useLocation} from 'react-router-dom';
import URL from '../../../../../constants/url';
import noDataImg from '../../../../../images/common/i_3d_no_data_doc.svg';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Skeleton from '@mui/material/Skeleton';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';


const choList = [
  { label: '전체', value: 'all' },
  { label: 'ㄱ', value: 'ㄱ' },
  { label: 'ㄴ', value: 'ㄴ' },
  { label: 'ㄷ', value: 'ㄷ' },
  { label: 'ㄹ', value: 'ㄹ' },
  { label: 'ㅁ', value: 'ㅁ' },
  { label: 'ㅂ', value: 'ㅂ' },
  { label: 'ㅅ', value: 'ㅅ' },
  { label: 'ㅇ', value: 'ㅇ' },
  { label: 'ㅈ', value: 'ㅈ' },
  { label: 'ㅊ', value: 'ㅊ' },
  { label: 'ㅋ', value: 'ㅋ' },
  { label: 'ㅌ', value: 'ㅌ' },
  { label: 'ㅍ', value: 'ㅍ' },
  { label: 'ㅎ', value: 'ㅎ' },
];

// 초성 추출 함수
const getChosung = (str) => {
    if (!str || typeof str !== 'string' || str.length === 0) return '';

    const cho = ["ㄱ", "ㄲ", "ㄴ", "ㄷ", "ㄸ", "ㄹ", "ㅁ", "ㅂ", "ㅃ", "ㅅ",
                "ㅆ", "ㅇ", "ㅈ", "ㅉ", "ㅊ", "ㅋ", "ㅌ", "ㅍ", "ㅎ"];

    const firstChar = str[0];
    const code = firstChar.charCodeAt(0) - 44032;

    // 한글 음절 범위 밖이면 그대로 반환
    if (code < 0 || code > 11171) return firstChar;

    return cho[Math.floor(code / 588)];
};



const DepartmentInform = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { hospitCd } = location.state || {};

    
    //데이터 
    const DeptInfoParam = {hsptlCd : hospitCd};
    const [mvTcDept, setMvTcDept] = useState([]);
    const [hospNm, setHospNm] = useState();

    // 탭 상태 sessionStorage key
    const tabKey = `dept-tab-${DeptInfoParam.hsptlCd}`;
    const scrollKey = `deptInformScrollY-${DeptInfoParam.hsptlCd}`;
    

    //전송중 체크
    const isSendingRef = useRef(false);

    //로딩
    const [isLoading, setIsLoading] = useState(false);
    
    //탭
    const [value, setValue] = useState('all');
    const handleChange = (event, newValue) => {
        setValue(newValue);
        sessionStorage.setItem(tabKey, newValue);
        sessionStorage.setItem(scrollKey, window.scrollY.toString());
    };

    // 마운트 시 복원
    useEffect(() => {
            const savedTab = sessionStorage.getItem(tabKey);
            const savedY = sessionStorage.getItem(scrollKey);
    
            if (savedTab) {
                setValue(savedTab);
            }
    
    
            if (savedY !== null) {
                const y = parseInt(savedY, 10);
                let tries = 0;
                const maxTries = 30;
    
                const scrollToY = () => {
                    const scrollHeight = document.body.scrollHeight;
                    const viewportHeight = window.innerHeight;
    
                    if (scrollHeight > y + viewportHeight || tries > maxTries) {
                        window.scrollTo(0, y);
                        return;
                    }
    
                    tries++;
                    requestAnimationFrame(scrollToY);
                };
    
                // 초기화 후 시작
                requestAnimationFrame(scrollToY);
            }
        }, []);

    const handleDepartClick = (dept) => {
    sessionStorage.setItem(scrollKey, window.scrollY.toString());
    navigate(URL.HOSPITAL_DEPARTMENTDETAIL, {
      state: {
        hosptlCd: dept.hsptlCd,
        deptName: dept.deptNm,
        deptDesc: stripHtml(dept.grt),
        deptCode: dept.deptCd,
      }
    });
  };

    const hospitalName= (val)=> {
        var hosName = "";
        switch (val){
            case "011":
            hosName = "여의도성모병원";
            break;
            case "012":
            hosName ="서울성모병원";
            break;
            case "013":
            hosName ="의정부성모병원";
            break;
            case "014":
            hosName ="부천성모병원";
            break;
            case "015":
            hosName ="은평성모병원";
            break;
            case "016":
            hosName ="인천성모병원";
            break;
            case "017":
            hosName ="성빈센트성모병원";
            break;
            case "018":
            hosName ="대전성모병원";
            break;
            default:
            hosName ="성모병원"; 
            break;
        }
        return hosName;
    }  

    // 자모별 데이터 분류
    const deptByCho = useMemo(() => {
        const map = {
            all: mvTcDept.filter(item => item.deptNm && item.deptNm.length > 0),
        };

        choList.forEach(({ value }) => {
            if (value === 'all') return;
            map[value] = mvTcDept.filter(item => getChosung(item.deptNm) === value);
        });

        return map;
    }, [mvTcDept]);


    //태그 삭제
    const stripHtml = (html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    };


    //데이터 불러오기
    const getDeptInitInfo = useCallback(async () => {
    
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);

        const url = "/guide/dept/retrieveDeptList";

        try {
            const res = await axiosApi.post(url, DeptInfoParam);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const deptList = res.data.result.deptInfo;
                setMvTcDept(deptList);
                setHospNm(deptList[0].hsptlCd);
            } else {
                setMvTcDept([]);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    }, []);

    //console.log(mvTcDept)
    
    useEffect(() => {
        getDeptInitInfo();
    }, [getDeptInitInfo]);
     
    const handleOnBackClick = ()=> {
        sessionStorage.removeItem(scrollKey);
        sessionStorage.removeItem(tabKey);
        navigate(-1);
    }

    //초기 탭 포커스 사라짐 방지
    useEffect(() => {
        if (!isLoading && mvTcDept.length > 0) {
            const validTabs = choList.map(({ value }) => value);
            if (!validTabs.includes(value)) {
                setValue('all');
            }
        }
    }, [isLoading, mvTcDept, value]);
    
    
    return (
        <>
            <HeadSub title="진료과/의료진 안내" hospitalName={hospitalName(DeptInfoParam.hsptlCd)} onBack={handleOnBackClick}/>

            <div id="sub-content" data-type='c'>         
                <div className='inner-wrap' data-pad="normal">
                  
                    <div className={style['all-dpartment']}>
                            <TabContext value={value} >
                                <TabList
                                    onChange={handleChange}
                                    aria-label="lab API tabs example"
                                    variant="scrollable"
                                    scrollButtons={false}
                                    className={style['tab-header-box']}
                                >
                                    {choList.map(({ label, value }) => (
                                    <Tab key={value} label={label} value={value} disableRipple />
                                    ))}
                                </TabList>
                                
    
                            {choList.map(({ value }) => (
                                <TabPanel key={value} value={value} className={style['tap-content-wrap']}>
                                    <div className='animation-2'>
                                        <div className={style['tap-content-box']}>
                                            <div className={style['list-box']}>
                                                <ul>    
                                                    {isLoading ? (
                                                        Array.from({ length: 6 }).map((_, index) => (
                                                            <li key={index}>
                                                                <Skeleton variant="text" height={24} width="60%" style={{ marginBottom: 8 }} />
                                                                <Skeleton variant="text" height={20} width="80%" />
                                                            </li>
                                                        ))
                                                    ) : deptByCho[value].length > 0 ? (
                                                    deptByCho[value].map((dept, i) => (
                                                        <li key={i} onClick={()=> handleDepartClick(dept)}>
                                                        
                                                            <p>{dept.deptNm}</p>
                                                            <span>{dept.grt && dept.grt.trim() ? stripHtml(dept.grt) : ""}</span>
                                                        </li>
                                                    ))
                                                    ) : (
                                                        <li className={style['no-data-box']}>
                                                            <div className={style['img-box']}>
                                                                <object data={noDataImg} aria-hidden='true'></object>        
                                                            </div>
                                                            <p>해당 진료과가 없습니다.</p>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            ))} 
                                
                            </TabContext>

                    </div>      
                </div>
            </div>
        </>
    );
};

export default DepartmentInform;
